import { localize } from "@gtmhub/localization";
import { KpiTimeFilter } from "@webapp/kpis/models/kpis.models";
import { KpiComparisonLabelMap } from "./kpi-statistics.models";

export const comparisonLabelMaps: Record<KpiTimeFilter, Pick<KpiComparisonLabelMap, "currentPeriod">> = {
  week: { currentPeriod: localize("week_to_date") },
  month: { currentPeriod: localize("month_to_date") },
  "three-months": { currentPeriod: localize("three_months_to_date") },
  year: { currentPeriod: localize("year_to_date") },
  "all-time": { currentPeriod: localize("year_to_date") },
};

export const timeFilterToTimeUnitMap: Record<"all-time" | "three-months", "year" | "quarter"> = {
  "three-months": "quarter",
  "all-time": "year",
};
